import * as React from "react";
import { useState } from "react";
import { Button, Text } from "@fluentui/react-components";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useFilterStyles } from "../styles/filterStyles";
import SpreetailHeader from "../layout/SpreetailHeader";
import DateRangeFilter from "../filters/controls/DateRangeFilter";
import CampaignTypeFilter from "../filters/controls/CampaignTypeFilter";
import AttributionWindowFilter from "../filters/controls/AttributionWindowFilter";
import CrossSkuImpactFilter from "../filters/controls/CrossSkuImpactFilter";
import CustomerJourneyLengthFilter from "../filters/controls/CustomerJourneyLengthFilter";

const AttributionAnalysisRoute: React.FC = () => {
  const history = useHistory();
  const filterStyles = useFilterStyles();

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [campaignType, setCampaignType] = useState<string[]>([]);
  const [windowFocus, setWindowFocus] = useState("");
  const [crossSkuImpact, setCrossSkuImpact] = useState("");
  const [journeyLength, setJourneyLength] = useState("");

  const handleCancel = () => {
    setStartDate(null); setEndDate(null);
    setCampaignType([]); setWindowFocus(""); setCrossSkuImpact(""); setJourneyLength("");
    history.push("/");
  };

  const handleApply = async () => {
    console.log("Apply Attribution Analysis filters", { startDate, endDate, campaignType, windowFocus, crossSkuImpact, journeyLength });
    history.push("/");
  };

  const hasFilters = !!(startDate || endDate || campaignType || windowFocus || crossSkuImpact || journeyLength);

  return (
    <div className={filterStyles.filterContainer} style={{ height: "100%", minHeight: 0 }}>
      <SpreetailHeader />
      <div className={filterStyles.filterHeader}>
        <Text size={400} weight="semibold" style={{ color: "#0F172A" }}>
          Attribution Analysis
        </Text>
        <Text size={200} style={{ color: "#667085", opacity: 0.9, fontSize: "12px" }}>
          Choose some filters to sort through the data!
        </Text>
      </div>

      <div className={filterStyles.filterContent} style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
        <Box className={filterStyles.inputGroup}>
          <label className={filterStyles.labelText}>Date Range</label>
          <DateRangeFilter startDate={startDate} endDate={endDate} onChangeStart={setStartDate} onChangeEnd={setEndDate} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <CampaignTypeFilter value={campaignType} onChange={setCampaignType} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <AttributionWindowFilter value={windowFocus} onChange={setWindowFocus} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <CrossSkuImpactFilter value={crossSkuImpact} onChange={setCrossSkuImpact} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <CustomerJourneyLengthFilter value={journeyLength} onChange={setJourneyLength} />
        </Box>

        <div className={filterStyles.actionButtons}>
          <Button appearance="outline" size="medium" onClick={handleCancel} className={`${filterStyles.actionButton} ${filterStyles.cancelButton}`}
            style={{
              border: '1px solid #0461FE',
              color: '#0461FE'
            }}
          >Cancel</Button>
          <Button appearance="primary" size="medium" onClick={handleApply} disabled={!hasFilters} className={`${filterStyles.actionButton} ${filterStyles.applyButton}`}>Apply Filter</Button>
        </div>
      </div>
    </div>
  );
};

export default AttributionAnalysisRoute;


